export const forceScrollToTop = () => {
  // Multiple methods to ensure it works across all browsers
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  
  // For modern browsers
  if (window.history.scrollRestoration) {
    window.history.scrollRestoration = 'manual';
  }
}; 